import { createApp } from '@app/adapters/create-app'

import ReportGraphEditor from '../screens/graph-editor/components/graph-editor'
import GraphTitle from '../screens/graph-editor/components/graph-title'
import GraphActions from '../screens/graph-editor/components/graph-actions'
import createStore from '../screens/graph-editor/store/index'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='report-graph-editor']").each(function () {
    const store = createStore(JSON.parse(this.dataset.props))

    const graphEditorApp = createApp(ReportGraphEditor)
    graphEditorApp.use(store)
    graphEditorApp.mount(this)

    const subheaderLeft = document.querySelector('#graph-editor-subheader-left')
    if (subheaderLeft) {
      const graphTitleApp = createApp(GraphTitle)
      graphTitleApp.use(store)
      graphTitleApp.mount(subheaderLeft)
    }

    const subheaderRight = document.querySelector(
      '#graph-editor-subheader-right'
    )
    if (subheaderRight) {
      const graphActionsApp = createApp(GraphActions)
      graphActionsApp.use(store)
      graphActionsApp.mount(subheaderRight)
    }
  })
})
